import { Address } from '@/schema/address';
import { parseISO, isPast } from 'date-fns';
import router from '@/router';

export default class Utils {
	static isValidEmail(email: string) {
		const re = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

		return re.test(String(email).toLowerCase());
	}

	static isValidAddress(address: Address) {
		if (!address) {
			return false;
		}
		if (!(address.city && address.zip_code /* && address.iso_country_code*/)) {
			return false;
		}
		if (!(address.street_name && address.street_number) && !address.street_name_number_box) {
			return false;
		}

		return true;
	}

	static toUrlEncoded(obj) {
		return Object.keys(obj).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])).join('&');
	}

	static openInNewTab(target: string | { name: string; params?: Record<string, any> }) {
		const url = typeof target === 'string'
			? target
			: router.resolve(target).href;
		window.open(url, '_blank');
	}

	// Helper function to compute status from open_amount and due_date
	static computedStatus(openAmount: number, dueDate: string | null): string {
		if (openAmount === 0) {
			return 'CLOSED';
		}

		if (!dueDate) {
			return 'OPEN';
		}

		const due = parseISO(dueDate);

		if (isPast(due)) {
			return 'OVERDUE';
		}

		return 'OPEN';
	}
}
